/* Ezlo Sense v2: shared behaviour of the sections/ezs2-*.liquid blocks. Every section includes this file (defer);
   the guard makes the second include a no-op.
   Arcs ([data-ezs2-lip], the svg at the bottom of a section): full while the section's bottom edge is low on the
   screen, flat once it has risen to ~45% of the screen height (smoothstep in between). */
(function () {
  if (window.__ezs2Shared) return;
  window.__ezs2Shared = true;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lips = [], ticking = false;
  /* all the measuring first, then all the writing: one layout per frame, not one per arc */
  function update() {
    ticking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight, i, ts = [];
    for (i = 0; i < lips.length; i++) {
      var t = (vh - lips[i].parentElement.getBoundingClientRect().bottom) / (vh * 0.55);
      ts[i] = t < 0 ? 0 : t > 1 ? 1 : t;
    }
    for (i = 0; i < lips.length; i++) lips[i].style.transform = 'scaleY(' + (1 - ts[i] * ts[i] * (3 - 2 * ts[i])).toFixed(3) + ')';
  }
  function request() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
  /* off screen nothing moves (Arseniy 10-21: the page lagged): the wrapper of every Sense section gets .ezs2-off while
     it is out of view (200px early, so things are already running when they come in) and ezs2.css pauses every CSS
     animation inside it; the clips and the JS loops wait for their own section's view in its script */
  function offscreen() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) entries[i].target.classList.toggle('ezs2-off', !entries[i].isIntersecting);
    }, { rootMargin: '200px 0px' });
    Array.prototype.forEach.call(document.querySelectorAll('.shopify-section'), function (s) {
      if (s.querySelector('.ezs2, .ezs')) io.observe(s);
    });
  }
  function init() {
    offscreen();
    lips = Array.prototype.slice.call(document.querySelectorAll('[data-ezs2-lip]'));
    if (reduced || !lips.length) return;
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    window.addEventListener('load', request);   /* the first measure can run before the header and fonts settle */
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
